function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), React.createElement("path", {
  d: "M11.43 0h3.43C15.43 0 16 .5 16 1v13c0 .5-.57 1-1.14 1H9.73a2 2 0 01-3.46 0H1.14C.57 15 0 14.5 0 14V1c0-.5.57-1 1.14-1h3.43C5.47 0 6.35.4 7 1v12a1 1 0 102 0V1c.65-.6 1.54-1 2.43-1z"
})));